import { render, staticRenderFns } from "./myCollection.vue?vue&type=template&id=24b40f29&scoped=true&"
import script from "./myCollection.vue?vue&type=script&lang=js&"
export * from "./myCollection.vue?vue&type=script&lang=js&"
import style0 from "./myCollection.vue?vue&type=style&index=0&id=24b40f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b40f29",
  null
  
)

export default component.exports